var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-box',{attrs:{"mt":"8"}},[_c('c-text',{attrs:{"mb":"2","px":"4","fontSize":"15px","fontWeight":"600"}},[_vm._v("Post Activities")]),_c('c-box',{attrs:{"py":"4","px":"4"}},_vm._l((_vm.posts.slice(0, 5)),function(post,i){return _c('post-card',{key:i,attrs:{"post":post}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }